import PARENT from '../types';

const SETTINGS_PANE = `${PARENT}/PARAMETER_NAMES`;

export const SET_PRIMARY_PARAMETER_NAME = `${SETTINGS_PANE}/SET_PRIMARY_PARAMETER_NAME`;
export const SET_SECONDARY_PARAMETER_NAME = `${SETTINGS_PANE}/SET_SECONDARY_PARAMETER_NAME`;

export const SET_TYPE_FREQUENCY_HISTOGRAM = `${SETTINGS_PANE}/SET_TYPE_FREQUENCY_HISTOGRAM`;
export const SET_TYPE_FREQUENCY_BAR_CHART = `${SETTINGS_PANE}/SET_TYPE_FREQUENCY_BAR_CHART`;
export const SET_TYPE_FREQUENCY_PIE_CHART = `${SETTINGS_PANE}/SET_TYPE_FREQUENCY_PIE_CHART`;

export default SETTINGS_PANE;
